import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { INavigationItem } from '@mds/angular-layout-primeng';
import { Observable, map } from 'rxjs';
import { RequiredScopes } from '../models/required-scopes.model';
import { UserScopeParameterValueModel } from '../services/api-client';
import { OrganizationSwitchService } from '../services/organization-switch.service';
import { PrimeIcons } from 'primeng/api';

export function navigationGroupsFactory(
  organizationSwitchService: OrganizationSwitchService
): Observable<INavigationItem[]> {
  return organizationSwitchService
    .getOrganization()
    .pipe(map((model) => (model !== undefined ? buildMenuWithOrganization(model) : buildMenuWithoutOrganization())));
}

function inOrganization(routerLink: string, organization: UserScopeParameterValueModel | undefined): string {
  return `${organization?.value}/${routerLink}`;
}

function buildMenuWithOrganization(organization: UserScopeParameterValueModel) {
  return [
    {
      icon: 'mds mds-home',
      labelResource: _('Iam.Navigation.Home.Title'),
      routerLink: 'home',
    },
    {
      icon: PrimeIcons.BUILDING,
      labelResource: _('Iam.Navigation.MyOrganization.Title'),
      routerLink: inOrganization('my-organization', organization),
      state: {
        [RequiredScopes]: ['myorganization:read'],
      },
    },
    {
      icon: 'mds mds-organization',
      labelResource: _('Iam.Navigation.Organization.Title'),
      routerLink: inOrganization('organizations', organization),
      state: {
        [RequiredScopes]: ['organizations:read'],
      },
    },
    {
      icon: 'mds mds-group',
      labelResource: _('Iam.Navigation.Groups.Title'),
      routerLink: inOrganization('groups', organization),
      state: {
        [RequiredScopes]: ['groups:read'],
      },
    },
    {
      icon: 'mds mds-user',
      labelResource: _('Iam.Navigation.Users.Title'),
      routerLink: inOrganization('users', organization),
      state: {
        [RequiredScopes]: ['users:read'],
      },
    },
    {
      icon: 'mds mds-role',
      labelResource: _('Iam.Navigation.Roles.Title'),
      routerLink: inOrganization('roles', organization),
      state: {
        [RequiredScopes]: ['roles:read'],
      },
    },
    {
      icon: 'mds mds-application',
      labelResource: _('Iam.Navigation.Apps.Title'),
      routerLink: inOrganization('apps', organization),
      state: {
        [RequiredScopes]: ['apps:read'],
      },
    },
    {
      icon: 'mds mds-client',
      labelResource: _('Iam.Navigation.Clients.Title'),
      routerLink: inOrganization('clients', organization),
      state: {
        [RequiredScopes]: ['clients:read'],
      },
    },
    {
      icon: 'pi pi-clock',
      labelResource: _('Iam.Navigation.Sessions.Title'),
      routerLink: inOrganization('sessions', organization),
      state: {
        [RequiredScopes]: ['sessions:read'],
      },
    },
    {
      icon: 'pi pi-eye',
      labelResource: _('Iam.Navigation.Audits.Title'),
      routerLink: inOrganization('audits', organization),
      state: {
        [RequiredScopes]: ['audits:read'],
      },
    },
  ];
}

function buildMenuWithoutOrganization() {
  return [
    {
      icon: 'mds mds-home',
      labelResource: _('Iam.Navigation.Home.Title'),
      routerLink: 'home',
    },
  ];
}
